export function clearProps (listOfProps) {
  return props => {
    return listOfProps.map(x => ({ target: props.getTarget(x), value: null }))
  }
}

export function revertProps (originalValues) {
  return props => {
    return Object.entries(originalValues).map(([name, value]) =>
      ({ target: props.getTarget(name), value: value }))
  }
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/modifyProps.js